export default "__VITE_ASSET__Cx$GZ$th__"